// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_eX","advertDetailContactItem__link":"c-n_eY"};